import React from "react";
import { Box, Typography, Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { formatShortWeekdayDateTime } from "../../../../utils/dateUtils";

/** Primary download UI for `*_attachment` entities with `meta.downloadUrl`. */
export default function AttachmentDownloadPanel({
  fileName,
  meta,
  tc,
  containedBtnSx,
  onDownload,
}) {
  const ext = fileName.includes(".") ? fileName.split(".").pop().toUpperCase() : "FILE";
  return (
    <Box sx={{ p: 3, display: "flex", flexDirection: "column", alignItems: "center", gap: 2, py: 5 }}>
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "16px",
          bgcolor: tc.background.infoBox,
          border: `1px solid ${tc.border.main}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: "0.75rem", color: tc.text.secondary, letterSpacing: "0.02em" }}>{ext}</Typography>
      </Box>
      <Typography sx={{ fontSize: "0.9rem", fontWeight: 600, color: tc.text.strong, textAlign: "center", wordBreak: "break-word", maxWidth: 400 }}>
        {fileName}
      </Typography>
      {meta.createdAt && (
        <Typography sx={{ fontSize: "0.75rem", color: tc.text.secondary }}>Uploaded {formatShortWeekdayDateTime(meta.createdAt)}</Typography>
      )}
      <Button
        variant="contained"
        disableElevation
        startIcon={<DownloadIcon />}
        onClick={onDownload}
        sx={{
          ...containedBtnSx,
          mt: 1,
          px: 3,
          py: 1,
          fontSize: "0.875rem",
          borderRadius: "10px",
        }}
      >
        Download
      </Button>
    </Box>
  );
}
